<template>
    <div>
        <label class="form-label">{{ title }} <sup v-if="isRequired" class="text-danger">*</sup></label>
        <select v-model="internalValue" v-on:change="$emit('change', internalValue)" :class="cssClass">
            <option v-if="withEmptyValue || emptyValueTitle" :value="null">{{ emptyValueTitle ? emptyValueTitle : 'Выберите значение' }}</option>
            <template v-for="v in values">
                <option v-if="typeof v.when === 'undefined' || v.when" :value="v[optionKey]" :disabled="v.disabled">{{ v[optionTitle] }}</option>
            </template>
        </select>
        <div v-for="errorMess in errors" class="invalid-feedback">{{ errorMess }}</div>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            default: null,
        },
        values: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        optionKey: {
            type: String,
            required: false,
            default: 'key'
        },
        optionTitle: {
            type: String,
            required: false,
            default: 'value'
        },
        withEmptyValue: {
            type: Boolean,
            required: false,
            default: false,
        },
        emptyValueTitle: {
            type: String,
            required: false,
        },
        cssClass: {
            type: String,
            required: false,
            default: 'form-select',
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            internalValue: this.modelValue,
        };
    },
    watch: {
        modelValue(val) {
            this.internalValue = val;
        },
        internalValue(val) {
            this.$emit('update:modelValue', val);
        },
    },
};
</script>
